@if(windowWidth < 1000){
<!-- Mobile -->
<ion-menu contentId="main-content" menuId="main-menu">
  <div class="h-full flex flex-col overflow-y-auto">
    <div class="ml-4 mt-4 mb-2">
      <img
        src="assets/icon/romeo_black.svg"
        class="logo cursor-pointer"
        (click)="navigateTo('home')"
      />
    </div>

    <ul class="mt-4 space-y-1 px-2">
      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('home')"
        [ngClass]="isActiveRoute('home') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="home-outline" class="text-xl"></ion-icon>
        <span>Home</span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('agenda')"
        [ngClass]="isActiveRoute('agenda') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="calendar-outline" class="text-xl"></ion-icon>
        <span>Agenda</span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('customers')"
        [ngClass]="isActiveRoute('customers') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="people-outline" class="text-xl"></ion-icon>
        <span>Clienti</span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('operators')"
        [ngClass]="isActiveRoute('operators') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="person-outline" class="text-xl"></ion-icon>
        <span>Collaboratori</span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('expenses')"
        [ngClass]="isActiveRoute('expenses') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="card-outline" class="text-xl"></ion-icon>
        <span>Spese</span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('balance')"
        [ngClass]="isActiveRoute('balance') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="wallet-outline" class="text-xl"></ion-icon>
        <span>Bilancio</span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('materials')"
        [ngClass]="isActiveRoute('materials') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="cube-outline" class="text-xl"></ion-icon>
        <span>Inventario</span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
        (click)="navigateTo('settings')"
        [ngClass]="isActiveRoute('settings') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
      >
        <ion-icon name="settings-outline" class="text-xl"></ion-icon>
        <span>Impostazioni</span>
      </li>
    </ul>

    <ul class="mt-auto p-2 space-y-1">
      <li class="flex items-center gap-3 p-2 rounded-lg invisible">
        <ion-icon name="log-out-outline" class="text-xl"></ion-icon>
        <span></span>
      </li>

      <li
        class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray/20"
        (click)="navigateTo('account/logout')"
      >
        <ion-icon name="log-out-outline" class="text-xl"></ion-icon>
        <span>Logout</span>
      </li>
    </ul>
  </div>
</ion-menu>

<ion-header class="shadow-none" style="box-shadow: none">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-menu-button
        autoHide="false"
        class="text-[var(--primary-text-color)]"
        style="--color: var(--primary-text-color)"
      ></ion-menu-button>
    </ion-buttons>
    <div slot="start" style="margin-left: 10px">
      <img
        src="assets/icon/romeo_black.svg"
        class="logo"
        (click)="navigateTo('home')"
      />
    </div>
  </ion-toolbar>
</ion-header>

<ion-footer>
  <ion-toolbar class="footer-toolbar">
    <div class="w-full flex justify-center">
      <div class="w-full grid grid-cols-5 gap-4 max-w-[700px]">
        <div
          class="flex flex-col items-center justify-center"
          (click)="navigateTo('home')"
        >
          @if(isActiveRoute('home')) {
          <ion-icon name="grid" class="text-white"></ion-icon>
          } @else {
          <ion-icon
            name="grid-outline"
            class="text-[var(--primary-text-color)]"
          ></ion-icon>
          }
          <span
            class="text-xs"
            [ngClass]="isActiveRoute('home') ? 'text-white' : 'text-[var(--primary-text-color)]'"
            >Home</span
          >
        </div>
        <div
          class="flex flex-col items-center justify-center"
          (click)="navigateTo('agenda')"
        >
          @if(isActiveRoute('agenda')) {
          <ion-icon name="calendar" class="text-white"></ion-icon>
          } @else {
          <ion-icon
            name="calendar-outline"
            class="text-[var(--primary-text-color)]"
          ></ion-icon>
          }
          <span
            class="text-xs"
            [ngClass]="isActiveRoute('agenda') ? 'text-white' : 'text-[var(--primary-text-color)]'"
            >Agenda</span
          >
        </div>
        <div></div>
        <div
          class="flex flex-col items-center justify-center"
          (click)="navigateTo('customers')"
        >
          @if(isActiveRoute('customers')) {
          <ion-icon name="search" class="text-white"></ion-icon>
          } @else {
          <ion-icon
            name="search-outline"
            class="text-[var(--primary-text-color)]"
          ></ion-icon>
          }
          <span
            class="text-xs"
            [ngClass]="isActiveRoute('customers') ? 'text-white' : 'text-[var(--primary-text-color)]'"
            >Cerca</span
          >
        </div>
        <div
          class="flex flex-col items-center justify-center"
          (click)="navigateTo('operators')"
        >
          @if(isActiveRoute('operator')) {
          <ion-icon name="glasses" class="text-white"></ion-icon>
          } @else {
          <ion-icon
            name="glasses-outline"
            class="text-[var(--primary-text-color)]"
          ></ion-icon>
          }
          <span
            class="text-xs"
            [ngClass]="isActiveRoute('operator') ? 'text-white' : 'text-[var(--primary-text-color)]'"
            >Team</span
          >
        </div>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>

<ion-fab slot="fixed" vertical="bottom" horizontal="center" class="fab-up">
  <ion-fab-button class="big-fab" (click)="toggleOverlay()">
    @if(!overlayOpen){<ion-icon name="add"></ion-icon>} @else {<ion-icon
      name="close"
    ></ion-icon
    >}
  </ion-fab-button>
</ion-fab>

<ion-content id="main-content" class="mb-3">
  <ion-router-outlet></ion-router-outlet>
</ion-content>
} @else {
<!-- SIDEBAR -->
<aside class="fixed left-0 w-[17%] z-50 flex flex-col overflow-y-auto">
  <div class="ml-4 mt-4 mb-2">
    <img
      src="assets/icon/romeo_black.svg"
      class="logo cursor-pointer"
      (click)="navigateTo('home')"
    />
  </div>

  <ul class="mt-4 space-y-1 px-2">
    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('home')"
      [ngClass]="isActiveRoute('home') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="home-outline" class="text-xl"></ion-icon>
      <span>Home</span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('agenda')"
      [ngClass]="isActiveRoute('agenda') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="calendar-outline" class="text-xl"></ion-icon>
      <span>Agenda</span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('customers')"
      [ngClass]="isActiveRoute('customer') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="people-outline" class="text-xl"></ion-icon>
      <span>Clienti</span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('operators')"
      [ngClass]="isActiveRoute('operators') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="person-outline" class="text-xl"></ion-icon>
      <span>Collaboratori</span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('expenses')"
      [ngClass]="isActiveRoute('expenses') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="card-outline" class="text-xl"></ion-icon>
      <span>Spese</span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('balance')"
      [ngClass]="isActiveRoute('balance') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="wallet-outline" class="text-xl"></ion-icon>
      <span>Bilancio</span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('materials')"
      [ngClass]="isActiveRoute('materials') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="cube-outline" class="text-xl"></ion-icon>
      <span>Inventario</span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100"
      (click)="navigateTo('settings')"
      [ngClass]="isActiveRoute('settings') ? 'text-[var(--orange-text-color)] font-bold' : 'text-[var(--primary-text-color)]'"
    >
      <ion-icon name="settings-outline" class="text-xl"></ion-icon>
      <span>Impostazioni</span>
    </li>
  </ul>

  <ul class="mt-auto p-2 space-y-1">
    <li class="flex items-center gap-3 p-2 rounded-lg invisible">
      <ion-icon name="log-out-outline" class="text-xl"></ion-icon>
      <span></span>
    </li>

    <li
      class="flex items-center gap-3 p-2 rounded-lg cursor-pointer hover:bg-gray-100/20"
      (click)="navigateTo('account/logout')"
    >
      <ion-icon name="log-out-outline" class="text-xl"></ion-icon>
      <span>Logout</span>
    </li>
  </ul>
</aside>

<!-- CONTENUTO -->
<ion-content id="main-content" class="ml-[17%] bg-[var(--light-grey)]">
  <div class="relative overflow-hidden h-full">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-content>

<ion-fab
  slot="fixed"
  vertical="bottom"
  horizontal="end"
  class="fab-up right-[20%]"
>
  <ion-fab-button class="big-fab" (click)="toggleOverlay()">
    @if(!overlayOpen){<ion-icon name="add"></ion-icon>} @else {<ion-icon
      name="close"
    ></ion-icon
    >}
  </ion-fab-button>
</ion-fab>
}

<app-shortcut-overlay
  [open]="overlayOpen"
  (close)="toggleOverlay($event)"
></app-shortcut-overlay>

<p style="position: absolute; right: 10px; top: 10px" class="text-sm">
  v. 10-07-2027 08:00
</p>
